import {
  CODE_ENFANCE_360,
  CODE_LOOC,
  CODE_MFAC,
  CODE_MFO,
  CODE_REGIE_ENFANCE,
  CODE_REGIE_ENFANCE_360,
  CODE_REGIE_LOOC,
  CODE_REGIE_MFAC,
  CODE_REGIE_MFO,
  ENFANCE_CODES_PRIORITY,
  PREFIX_ENFANCE,
} from '@/constants/applicationSource';

// Helper pour vérifier si un code est un code Enfance (HOL_ENF, HOL_ENF3, HOL_ENF4)
export const isEnfanceCode = (code: string): boolean => code.startsWith(PREFIX_ENFANCE);

// Helper pour obtenir le code régie depuis un code JVS (gère les préfixes Enfance)
export const getRegieCodeFromJvs = (code: string): string | undefined => {
  if (isEnfanceCode(code)) return CODE_REGIE_ENFANCE;
  if (code === CODE_ENFANCE_360) return CODE_REGIE_ENFANCE_360;
  if (code === CODE_MFO) return CODE_REGIE_MFO;
  if (code === CODE_MFAC) return CODE_REGIE_MFAC;
  if (code === CODE_LOOC) return CODE_REGIE_LOOC;
  return undefined;
};

// Helper pour vérifier si une application est gérée
export const isHandledApplication = (code: string): boolean =>
  isEnfanceCode(code) ||
  code === CODE_ENFANCE_360 ||
  code === CODE_MFO ||
  code === CODE_MFAC ||
  code === CODE_LOOC;

// Helper pour obtenir la priorité d'un code application lors du dédoublonnage par code régie.
// Plus la valeur est basse, plus le code est prioritaire (cf. ENFANCE_CODES_PRIORITY).
export const getApplicationSourcePriority = (code: string): number => {
  const index = ENFANCE_CODES_PRIORITY.indexOf(code);
  return index === -1 ? ENFANCE_CODES_PRIORITY.length : index;
};
